export const TIMELINES_DATA = [
  {
    id: "2018",
    year: "2018",
    title: "some amazing title here",
    subtitle: "year theme title",
    text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    direction: "left",
    squarePos: "top",
  },
  {
    id: "2019",
    year: "2019",
    title: "some amazing title here",
    subtitle: "year theme title",
    text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    direction: "left",
    squarePos: "bottom",
  },
  {
    id: "2020",
    year: "2020",
    title: "some amazing title here",
    subtitle: "year theme title",
    text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    direction: "right",
    squarePos: "top",
  },
  {
    id: "2021",
    year: "2021",
    title: "some amazing title here",
    subtitle: "year theme title",
    text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    direction: "right",
    squarePos: "bottom",
    hasBottomTriangle: true,
  },
  {
    id: "2022",
    year: "2022",
    title: "some amazing title here",
    subtitle: "year theme title",
    text: "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.",
    direction: "bottom",
  },
];
